<template>
  <div id="app" :style="appStyle">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      appStyle: {
        height: this.fHeight
      },
      fHeight: '0px'
    }
  },
  computed: {
  },
  methods:{
    _isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    }
  },
  mounted () {
    this.fHeight = window.innerHeight
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue